import { render, staticRenderFns } from "./ask.vue?vue&type=template&id=54cf48f8&scoped=true"
import script from "./ask.vue?vue&type=script&lang=js"
export * from "./ask.vue?vue&type=script&lang=js"
import style0 from "./ask.vue?vue&type=style&index=0&id=54cf48f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf48f8",
  null
  
)

export default component.exports